import React from 'react';
import { IonButton, IonText } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { DrawerSectionHeading } from '../../components/DrawerSectionHeading';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../../caremap/CareMapState';
import { AddNoteButton } from '../add-note/AddNoteButton';
import { ICaremapNote } from '../model/NotesClient';
import { sortByNewest } from '../../utils/arrays';
import { CareMapNotesListItem } from './CareMapNotesListItem';

const useStyles = createUseStyles({
    addLink: {
        cursor: 'pointer',
        color: 'var(--ion-color-primary)'
    }
});

type INotesProps = {
    notes?: ICaremapNote[];
    moreNotesHandler?: () => void;
    onNoteClicked: (noteId: string) => void;
    onAddNote: () => void;
    showCount?: number;
    showHeading?: boolean;
    'data-type'?: string;
    showNoteTargetHeader?: boolean;
};
export const CareMapNotesList: React.FC<INotesProps> = ({
    notes,
    moreNotesHandler,
    onNoteClicked,
    onAddNote,
    showCount,
    showHeading = true,
    'data-type': dataType = 'notes-list',
    showNoteTargetHeader
}) => {
    const classes = useStyles();
    const careMapState = useInstance(CareMapState);

    // intentionanlly not subscribing b/c this cannot change
    const canEdit = careMapState.getActiveCaremap()!.links.self.actions.includes('edit-notes');

    notes = sortByNewest(notes || [], 'updatedAt');

    const visibleNotes: ICaremapNote[] = notes.slice(0, showCount);

    const isAnytingToSee = canEdit || visibleNotes.length > 0;
    if(!isAnytingToSee) {
        return null;
    }

    return (
        <div style={{ width: '100%' }} data-type={dataType}>
            {showHeading && (
                <DrawerSectionHeading text="Notes">
                    <AddNoteButton
                        useIcon
                        canAdd={canEdit}
                        onClick={onAddNote}
                    />
                </DrawerSectionHeading>
            )}

            {visibleNotes.length === 0 && canEdit && (
                <IonText color="medium" style={{paddingLeft: 12}}>
                    No notes yet, <span className={classes.addLink} onClick={onAddNote}>add one</span>
                </IonText>
            )}

            {(canEdit || visibleNotes.length > 0) && visibleNotes.map(note => {
                return (
                    <CareMapNotesListItem
                        note={note}
                        key={note.noteId}
                        showNoteTargetHeader={showNoteTargetHeader}
                        onClick={() => onNoteClicked(note.noteId)}
                    />
                );
            })}

            {(showCount && showCount < notes.length && moreNotesHandler) && (
                <div style={{display: 'flex', justifyContent: 'space-around', marginBottom: -24}}>
                    <IonButton fill="clear" onClick={moreNotesHandler} data-id="view-more-notes-button">View More Notes</IonButton>
                </div>
            )}
        </div>
    );
};
